import { useAgreementContext } from "../AgreementContext";
import { useStartAgreement } from "../hooks/useStartAgreement";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { AgreementSummary } from "../components/AgreementSummary";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import React from "react";
import { usePermissions } from "@poseidon/ui/components";

export const PendingAgreementPage = () => {
  const { canWrite } = usePermissions();
  const agreement = useAgreementContext();
  const { error, saving, success, startAgreement } = useStartAgreement(
    agreement.id
  );
  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <Typography align="left" variant="h5">
        Manage Agreement {agreement.agreementNumber}
      </Typography>
      <AgreementSummary agreement={agreement} />
      <Box sx={{ mb: 5 }}>
        <Button
          variant="contained"
          disabled={saving || success || !canWrite}
          onClick={() => startAgreement()}
        >
          Start agreement
        </Button>
        {saving && <LinearProgress />}
        {success && "Started!"}
        {error && "Error!"}
      </Box>
    </Stack>
  );
};
